export default __webpack_public_path__ + "img/f44f3f6d71b4a48fce579017896a057e.svg";